<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="fillet">
      <div class="retrieval">
        <!-- 表头设置控件 -->
        <div class="right">
          <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
            @onChange="onTableSelect" />
        </div>
      </div>
    </div>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'escortrec',
      breadcrumb: [
        { name: "财务管理", path: "/finance/captainSalary" },
        { name: "车队长工资表", path: "/finance/captainSalary" },
        { name: "当月运单" },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 120 },
        { keyName: "name", label: "货物名称" },
        { keyName: "shname", label: "客户名称" },
        { keyName: "coaddress", label: "装货地址", minwidth: 220 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 220 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', width: 110 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', width: 140 },
        { keyName: "dtonprices", label: "亏吨单价", align: 'right', className: 'pr30', width: 110 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', width: 110 },
        { keyName: "message", label: "信息费", align: 'right', className: 'pr30', width: 110 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', width: 110 },
        { keyName: "freight", label: "运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "total", label: "出车费用", align: 'right', className: 'pr30', width: 110 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', width: 110 },
        { keyName: "profit", label: "利润", align: 'right', className: 'pr30', width: 110 },
      ],
      baseParams: ['month', 'fleet'],
      getTotalProperty: [
        'inton',
        'unton',
        'kuiton',
        'ceton',
        'kuitotal',
        'message',
        'freight',
        'total',
        'compen',
        'profit',
      ],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.fillet {
  height: auto;
  margin: 0 auto;
  padding: 0 0 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .retrieval {
    height: 52px;
    /* overflow: hidden; */
    margin: 0px 20px;
    font-size: 14px;
    color: #606266;
    // display: flex;
    // justify-content: space-between;
    position: relative;

    .right {
      position: absolute;
      right: 10px;
    }
  }
}
</style>
